import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getPropertyDetails } from '../../services/PropertyDetailsAPI';
import { toastNotify } from '../../utils/toastNotify';
import { getUsCurrencyFormat } from '../../utils/usCurrencyFormatter';

const initialState = {
  loading: false,
  data: {},
  unitMix : [],
};

export const fetchPropertyDetailsAction = createAsyncThunk('FETCH_PROPERTY_DETAILS', getPropertyDetails);
export const propertyDetailsSlice = createSlice({
  name: 'propertyDetails',
  initialState,
  reducers: {
    updatePropertyDetailsLoading: (state, action) => {
      state.loading = action.payload;
    },
    updatePropertyDetails: (state, action) => {
      state.data = { ...action.payload };
    }
  },
  extraReducers: {
    [fetchPropertyDetailsAction.pending]: (state, action) => {
      return {
        ...state,
        loading: true,
      };
    },
    [fetchPropertyDetailsAction.fulfilled]: (state, action) => {
      const { payload: propertyDetails } = action;
      return {
        ...state,
        data: propertyDetails,
        loading: false,
        unitMix: propertyDetails?.data?.unitMix?.unitMix ? 
        propertyDetails.data.unitMix.unitMix.map(item => ({...item, percentage: getUsCurrencyFormat(item?.percentage)})) : 
        [],
      };
    },
    [fetchPropertyDetailsAction.rejected]: (state, action) => {
      toastNotify('error', action.payload);
      return {
        ...state,
        loading: false,
        data: {},
      };
    },
  },
});

export const { updatePropertyDetails, updatePropertyDetailsLoading } = propertyDetailsSlice.actions;
const { reducer } = propertyDetailsSlice;

export default reducer;
